import { render } from "./ImageSlider.vue?vue&type=template&id=d96c3f18&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"

import "./ImageSlider.vue?vue&type=style&index=0&id=d96c3f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96c3f18"]])

export default __exports__